import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SupervisorGroupsRequest, SupervisorGroupsRequestStores, SupervisorGroupsRequestUsers } from '../../../../../models/api-store/supervisor-groups/supervisor-groups.request.model';

import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { SupervisorGroupsService } from '../../../../../services/api-store/supervisor-groups/supervisor-groups.service';
import { UserService } from '../../../../../services/user/user.service';
import { Router } from '@angular/router';
import { TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-supervisori-edit',
  templateUrl: './supervisori-edit.component.html',
  styleUrls: ['./supervisori-edit.component.css']
})
export class SupervisoriEditComponent implements OnInit {

  @Input() id:number;
  formBuilder: FormGroup;
  request:any = {};
  response:any = null;
  isButtonSaveDisabled:boolean;
  @ViewChild('selectUser') selectUser;

  stores = [];
  users = [];

  saveObj:any = {
    supervisor:null,
    stores:null,
    users:null
  }

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private spinner: SpinnerService,
    private supervisorGroupsService: SupervisorGroupsService,
    private userService: UserService,
    private toastr: ToastrService,
    private router: Router,
  ) { 
    this.initForm();
  }

  ngOnInit(): void {
    this.loadDataByID(this.id);
  }

  get form(){return this.formBuilder;}
  get formControls() { return this.formBuilder.controls; }

  loadDataByID(idObj){
    this.spinner.show();
    this.supervisorGroupsService.getEntity(idObj).subscribe(
      (response) => {
        if(response){
          this.setFormValue(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni della promozione/evento' , 'Load promozione/evento', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  initForm(){
    this.formBuilder = this.fb.group({
      name: ['',[Validators.required]]
    });
    this.isButtonSaveDisabled = false;
  }

  getFormValue(){
    let request = new SupervisorGroupsRequest();
    request.name = this.formBuilder.controls['name'].value;
    return request;
  }

  getFormRemovedStore(){
    let removedStore = new SupervisorGroupsRequestStores();
    removedStore.storeIds = [];
    for (let store of this.stores) {
      if(store['del'] === TRUE){
        removedStore.storeIds.push(store.id);
      }
    }
    return removedStore;
  }

  getFormRemovedUser(){
    let removedUser = new SupervisorGroupsRequestUsers();
    removedUser.userIds = [];
    for (let user of this.users) {
      if(user['del'] === TRUE){
        removedUser.userIds.push(user.id);
      }
    }
    return removedUser;
  }

  setFormValue(response){
    this.formBuilder.controls['name'].setValue(response.name);
    //Carica users
    if(response.users!=null){
      for (let obj of response.users) {
        obj['del']=false;
        this.users.push(obj);
      }
    }
    
    //Carica stores
    if(response.stores!=null){
      for (let obj of response.stores) {
        obj['del']=false;
        this.stores.push(obj);
      }
    }
    
  }

  save(){
    this.request = this. getFormValue();
    let removedStores = this.getFormRemovedStore();
    let removedUsers = this.getFormRemovedUser();
    if(removedStores.storeIds.length > 0){
      this.supervisorGroupsService.removeStores(this.id,removedStores).subscribe(
        (response) => {
          if(response){
            //Salvato
            this.saveObj.stores = true;
            this.checkSave();
          }
        },
        (error: HttpErrorResponse) => {
          this.saveObj.stores = false;
          this.isButtonSaveDisabled = false;
          this.toastr.error('Si è verificato un errore durante la rimozione degli store' , 'Modifica store supervisore fallita', {
              timeOut: 5000
          });
          this.checkSave();
        }
      );
    }else{
      this.saveObj.stores = true;
    }
    

    if(removedUsers.userIds.length > 0){
      this.supervisorGroupsService.removeUsers(this.id,removedUsers).subscribe(
        (response) => {
          if(response){
            //Salvato
            this.saveObj.users = true;
            this.checkSave();
          }
        },
        (error: HttpErrorResponse) => {
          this.saveObj.users = false;
          this.isButtonSaveDisabled = false;
          this.toastr.error('Si è verificato un errore durante la rimozione degli utenti' , 'Modifica utenti supervisore fallita', {
              timeOut: 5000
          });
          this.checkSave();
        }
      );
    }else{
      this.saveObj.users = true; 
    }
    

    this.supervisorGroupsService.update(this.id,this.request).subscribe(
      (response) => {
        if(response){
          //Salvato
          this.saveObj.supervisor = true;
          this.response = response;
          this.checkSave();
        }
      },
      (error: HttpErrorResponse) => {
        this.saveObj.supervisor = false;
        this.isButtonSaveDisabled = false;
        this.toastr.error('Si è verificato un errore durante la modifica' , 'Modifica supervisore fallita', {
            timeOut: 5000
        });
        this.checkSave();
      }
    );
  }

  checkSave(){
    if(
        this.saveObj.supervisor == TRUE &&
        this.saveObj.stores == TRUE &&
        this.saveObj.users == TRUE){
          this.toastr.success('Modificato con successo', 'Modifica supervisore');
          this.isButtonSaveDisabled = true;
          this.activeModal.close(this.response);
        }
  }

  clickButtonSave(){
    if(this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE){
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

  clickButtonCancel() {
    this.activeModal.close('CLOSE');
  }

  clickButtonGoToStore(id) {
    const url = 'store/store/' + id;
    this.router.navigate([url], { queryParams: { history: true }, queryParamsHandling: 'preserve' });
    this.clickButtonCancel();
  }


  clickButtonChangeDelStore(id,val){
    let indexToRemove = -1;
    for(let i=0;i < this.stores.length && indexToRemove==-1; i++){
      if(this.stores[i].id === id){
        indexToRemove = i;
        this.stores[i].del = val;
      }
    }
  }

  clickButtonChangeDelUser(id,val){
    let indexToRemove = -1;
    for(let i=0;i < this.users.length && indexToRemove==-1; i++){
      if(this.users[i].id === id){
        indexToRemove = i;
        this.users[i].del = val;
      }
    }
  }




}
